import React, {Fragment} from "react";
// import { Header } from "components/session/index";
// import {Footer} from "components/common/index";
// import ChangePasswordContainer from "../../containers/session/ChangePasswordContainer";
// import ResetPasswordWithTokenContainer from "../../containers/session/ResetPasswordWithTokenContainer";
// import addlogo from "assets/images/header/alldaydrlogo.png";
// import blackphone from "assets/images/header/blackphone.png";
// import {ErrorBoundary} from "../../app/ErrorBoundary";
import ResetPasswordWithTokenContainer from "containers/Login/ResetPasswordWithTokenContainer";

const ResetPasswordWithTokenPage = (props) => {
  return (
    <Fragment>
      {/* <Header /> */}
      {/* <div className="full-gray-bg padding-40-t padding-40-b">
        <div className="container">
          <div className="text-left inner-header">
            <div className="in-block no-float max-width-1020">
              <h3 className="font-32 weight-500 text-left text-black">
                Set Password
              </h3>
            </div>
          </div>
        </div>
      </div> */}
      {/* <Fragment> */}
      {/* <div className="withoutlogin-header">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-6">
                <a className="logo-link" href="/">
                  <img alt=""></img>
                </a>
              </div>
              <div className="col-md-6 d-flex justify-content-end">
                <div className="in-block vertical-middle margin-right-10">
                  <img
                    // src={blackphone}
                    className="img-responsive"
                    alt="Call"
                    width="21"
                  ></img>
                </div>
                <div className="in-block vertical-middle">
                  <p className="font-12 weight-500 text-light-black push-5-b line-height-12">
                    Customer Support?
                  </p>
                  <p className="font-12 weight-400 text-light-black push-0-b line-height-12">
                    Call on +0208 0166 020
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      {/* <ErrorBoundary isFromRestrctedRoute> */}
      {/* <div className="container-fluid">
            <div className="login-wrapper">
              <div className="row login-title-wrapper">
                <div className="col-md-12">
                  <h1 className="login-title-h1">Reset Password</h1>
                </div>
              </div>

              <div className="login-wrapper-inner"> */}

      <div className="login_page">
        <ResetPasswordWithTokenContainer />
      </div>
      {/* </div>
            </div>
          </div> */}
      {/* </ErrorBoundary> */}
      {/* </Fragment> */}
      {/* <Footer /> */}
    </Fragment>
  );
};

export default ResetPasswordWithTokenPage;
